// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3vtBE","message":"styles_message__2iDW6"};